import { RoleCode } from "./role.enum";

/**
 * Funkcja odpowiedzialna za zwracanie domyślnej ścieżki na podstawie roli użytkownika
 * @since 28.05.2026
 */
export function getDefaultRouteByRole(role?: string | null): string {
  return role === RoleCode.factory ? "/production/board" : "/dashboard";
}
